var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-calendar",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,1.5v-1C5,0.224,4.776,0,4.5,0h-1C3.224,0,3,0.224,3,0.5v1C3,1.776,3.224,2,3.5,2h1C4.776,2,5,1.776,5,1.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,1.5v-1C13,0.224,12.776,0,12.5,0h-1C11.224,0,11,0.224,11,0.5v1C11,1.776,11.224,2,11.5,2h1C12.776,2,13,1.776,13,1.5z       "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,3h-3C10.224,3,10,2.776,10,2.5v-2C10,0.224,9.776,0,9.5,0h-3C6.224,0,6,0.224,6,0.5v2C6,2.776,5.776,3,5.5,3h-3       C2.224,3,2,2.776,2,2.5v-2C2,0.224,1.776,0,1.5,0H1C0.448,0,0,0.447,0,1v14c0,0.553,0.448,1,1,1h14c0.552,0,1-0.447,1-1V1       c0-0.553-0.448-1-1-1h-0.5C14.224,0,14,0.224,14,0.5v2C14,2.776,13.776,3,13.5,3z M14,14H2V5h12V14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a4ccbb30ebc8e0b6f21b41e973c6c549.svg";
export { ForwardRef as ReactComponent };